import { Box, CircularProgress, Typography } from '@mui/material';

const LoadingIndicator = ({ show, loadingMessage }) => {
  if (!show) return null;

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '80vh',
      }}
    >
      <CircularProgress />
      <Typography variant="h6" sx={{ mt: 4 }}>
        {loadingMessage}
      </Typography>
    </Box>
  );
};

export default LoadingIndicator;
